import { createFileRoute } from '@tanstack/react-router'
import { GlobalTab } from '~/components/routes/visioReviews/GlobalTab'
import { VisioReviewsLayout } from '~/components/routes/visioReviews/VisioReviewsLayout'
import {
  useVisioReviewsPeriod,
  visioReviewsSearchSchema,
} from '~/components/routes/visioReviews/search'
import { VISIO_REVIEWS_TAB_PERMISSIONS } from '~/components/routes/visioReviews/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/visio-reviews/global')({
  staticData: {
    permission: VISIO_REVIEWS_TAB_PERMISSIONS.global,
  },
  validateSearch: visioReviewsSearchSchema,
  component: VisioReviewsGlobalPage,
})
withRoutePermissions(Route)

function VisioReviewsGlobalPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const { dateRange, previousPeriod } = useVisioReviewsPeriod(search)

  return (
    <VisioReviewsLayout
      activeTab="global"
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    >
      <GlobalTab dateRange={dateRange} previousPeriod={previousPeriod} />
    </VisioReviewsLayout>
  )
}
